import { AnyAction } from 'redux';

import { carsActions } from '../reducer';

export const resetSelectedCarEBoxLocation = (): AnyAction => carsActions
  .setSelectedEBoxLocation(undefined);
